import { Feature as GeoFeature, FeatureCollection as GeoFeatureCollection, Geometry, Position } from "geojson";

export const FEATURE = "Feature";

export enum GeometryType {
    POINT = "Point",
    MULTI_POINT = "MultiPoint",
    LINE_STRING = "LineString",
    MULTI_LINE_STRING = "MultiLineString",
    POLYGON = "Polygon",
    MULTI_POLYGON = "MultiPolygon",
    GEOMETRY_COLLECTION = "GeometryCollection",
}

export enum Features {
    AIRSPACE = "Ase",
    GEOBORDER = "Gbo",
    ROUTE = "Rte",
    AIRPORT = "Ahp",
}

export type FeatureStyle = {
    weight: number;
    fillOpacity: number;
    fillColor: string;
    color: string;
    radius: number;
};

export enum LineSegmentType {
    ARC_BY_EDGE = "ArcByEdge",
    ARC_BY_ANGLES = "ArcByAngles",
    FOLLOWS_GEO_BORDER = "FollowsGeoBorder",
    GREAT_CIRCLE = "GreatCircle",
}

export enum SegmentProperties {
    POINT = "point",
    INDEX = "index",
    ARC_POINT = "arcPoint",
    CENTER = "center",
    RADIUS = "radius",
    BEARING_1 = "bearing1",
    BEARING_2 = "bearing2",
    GEO_BORDER_ID = "geoBorderId",
}

export interface Vertex {
    index: number;
    point: Position;
    length?: number;
    modifiedIndex: number;
}

export interface LineSegment<VertexType extends Vertex = Vertex> {
    type: LineSegmentType;
    properties: VertexType;
}

export interface ArcByEdge extends Vertex {
    arcPoint: Position;
    endPoint: Position;
}

export interface ArcByAngles extends Vertex {
    center: Position;
    radius: number;
    bearing1: number;
    bearing2: number;
    endPoint: Position;
    perpendicularPoints: Position[];
    arcPoint: Position;
}

export interface FollowsGeoBorder extends Vertex {
    geoBorderId: string;
    geoBorderCoordinates: Position[];
}

export interface GreatCircle extends Vertex {}

export interface Corridor {
    width: number;
}

export type FeatureProps = {
    id: string;
    style?: FeatureStyle;
    densifyGeometry?: boolean;
    newFeature?: boolean;
    featureType?: string;
    featureId?: number;
    featureForm?: string;
    featureShortName?: string;
    slotId?: number;
    naturalKey?: string;
    layer?: string;
    isCircle?: boolean;
    radius?: number;
    segments?: LineSegment<GreatCircle | ArcByAngles | ArcByEdge | FollowsGeoBorder>[] | undefined;
    originalCoordinates?: number[][];
    corridor?: Corridor;
    type?: string;
    name?: string;
};

export type GeometryCoordinates = Position | Position[] | Position[][] | Position[][][];

export type FeatureGeometry = Geometry;

export type Feature = GeoFeature<FeatureGeometry, FeatureProps>;
export type FeatureCollection = GeoFeatureCollection<FeatureGeometry, FeatureProps>;
